/* 联系我们弹框 */
<template>
  <Modal
    v-model="contactMdl"
    footer-hide
    id="vertical-center-modal"
    width="420"
    class-name="vertical-center-modal no-padding"
  >
    <div class="close-btn" slot="close">
      <i class="iconfont icon-pop-close"></i>
    </div>
    <div class="contact-cont">
      <span>
        <p>联系住逻辑客服</p>
        <img src="https://oss.zhulogic.com/operation_picture/customerService.png" alt>
      </span>
      <p class="phone">请拨打电话：400-998-0137</p>
      <p class="time">服务时间：9:00-18:00</p>
    </div>
  </Modal>
</template>
<script>
export default {
  data() {
    return {
      contactMdl: false
    };
  },
  methods: {
    open() {
      this.contactMdl = true;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
#vertical-center-modal .ivu-modal-mask {
  z-index: 6000;
}
#vertical-center-modal .vertical-center-modal {
  z-index: 6100;
}
#vertical-center-modal .ivu-modal-body {
  padding: 0px !important;
}
.contact-cont {
  padding-bottom: 61px;
  > span {
    display: inline-block;
    position: relative;
    > p {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 19px;
      font-size: 16px;
      color: #353838;
    }
  }
  i {
    font-size: 44px;
    color: #308697;
  }
  .phone {
    font-size: 20px;
    color: #353838;
    letter-spacing: 0;
    text-align: center;
    margin-top: 24px;
  }
  .time {
    font-size: 14px;
    color: #308697;
    letter-spacing: 0;
    text-align: center;
    margin-top: 9px;
  }
}
</style>
<style scoped>
.contact-cont p.text {
  font-size: 12px;
  color: #308697;
  text-align: center;
}
.ivu-modal .ivu-modal-close .iconfont {
  color: #fff;
}
</style>